import MSCartesian from '@fusioncharts/charts/src/chart/_internal/mscartesian';
import { _setDefaultConfig } from '@fusioncharts/charts/src/chart/_internal/areabase';
import ErrorLineDataset from '../../dataset/errorline';

const ERRORLINE = 'errorline';
class ErrorLine extends MSCartesian {
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'ErrorLine';
  }

  constructor () {
    super();
    this.useErrorGroup = true;
    this.isErrorChart = true;
    this.hasAnchor = true;
    // this.fireGroupEvent = true;
    this.defaultPlotShadow = 1;
    this.axisPaddingLeft = 0;
    this.axisPaddingRight = 0;
    this.canvasPaddingModifiers = ['anchor', 'errorbar'];
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'ErrorLine';
  }
  __setDefaultConfig () {
    super.__setDefaultConfig();
    let config = this.config;
    config.defaultDatasetType = ERRORLINE;
    _setDefaultConfig.call(this);
    this.zeroplanethickness = 1;
    this.zeroplanealpha = 40;
    config.showzeroplaneontop = 0;
    config.defaultcrosslinethickness = 1;
    config.enablemousetracking = true;
  }
  getDSGroupdef () {
    // this fn overrides
  }
  getDSdef () {
    return ErrorLineDataset;
  }
}
export default ErrorLine;
